import client from "@/api/client"

export type InboxNotification = {
  _id: string
  title?: string
  body: string
  createdAt: string
  type?: string
  data?: Record<string, unknown>
  readAt?: string | null
}

export type NotificationsResponse = {
  data: InboxNotification[]
  totalItems?: number
  totalPages?: number
  unreadCount?: number
}

export type GetNotificationsParams = {
  page?: number
  pageSize?: number
}

export const getNotifications = async (params?: GetNotificationsParams) => {
  const response = await client.get("/api/v1/customer/notifications", {
    params: {
      page: params?.page ?? 1,
      pageSize: params?.pageSize ?? 20,
    },
  })
  return response.data as NotificationsResponse
}

export const markNotificationRead = async (id: string) => {
  const response = await client.patch(`/api/v1/customer/notifications/${id}/read`)
  return response.data
}

export const markAllNotificationsRead = async () => {
  const response = await client.post("/api/v1/customer/notifications/read-all")
  return response.data
}
